$(window).bind('hashchange', function () {
  var $el = $("[data-industry='" + location.hash.replace('#', '') + "']:visible");

  if (!$el.length) {
    $('.js-section-home').addClass('is-active');
    $('.js-section-inside').removeClass('is-active');

    // adjust nav to match new selection
    $(".js-tab-nav").removeClass('is-active');
  }

  $el.triggerHandler("click");
});

$(function() {
  // We support JS, remove the "no-js" class.
  $("html").removeClass("no-js");

  // Tooltips
  $('.js-tooltip').each(function() {
    $(this).qtip({
      content: {
        text: $(this).next('small') // Use the "small" element next to this for the content
      },
      position: {
        my: 'bottom left',
        at: 'top right'
      }
    });
  });

  // Print button
  $('.js-print').click(function(e) {
    window.print();

    // no clicky
    e.preventDefault();
  });

  // Tab navigation
  $(".js-tab-nav").click(function(e) {
    var $el = $(this);
    var target = $el.attr("href");

    // if home section is open, close it
    $('.js-section-home').removeClass('is-active');
    $('.js-section-inside').addClass('is-active');

    // adjust nav to match new selection
    $(".js-tab-nav").removeClass('is-active');
    $(".js-tab-nav[href=" + target + "]").addClass('is-active');

    // remove all active tabs and make targetted one active
    $('.js-tab').removeClass('is-active');
    $(target).addClass('is-active');

    if (location.hash != $el.attr("data-industry")) {
      location.hash = $el.attr("data-industry");
    }

    $('html, body').scrollTop($("#section-inside").offset().top);

    // no clicky
    e.preventDefault();
  });

  // Row toggle buttons
  $(".js-row-toggle").click(function(e) {
    var el = $(this),
      icon = el.children('.fa');

    // swap icons
    if (icon.hasClass('fa-plus-square-o')) {
      icon.removeClass('fa-plus-square-o').addClass('fa-minus-square-o');
    } else {
      icon.removeClass('fa-minus-square-o').addClass('fa-plus-square-o');
    }

    // open or close div
    el.parents('.js-row').next('.js-row-toggle-target').toggleClass('is-open');

    // no clicky
    e.preventDefault();
  });

  // Reset form
  $(".js-reset-form").click(function(e) {
    // no clicky
    e.preventDefault();

    if (confirm("Reset all values in the current industry?") == true) {
      var $industry = $(this).parents(".js-tab");
      var $el = null;

      $industry.find(".js-item-hours, .js-item-value, .js-profit-margin, .js-sales").each(function () {
        $el = $(this);
        var valueDefault = $el.attr("data-default");
        var valueCurrent = $el.val();

        if (valueCurrent != valueDefault) {
          $el.val(valueDefault);

          $el.triggerHandler("keyup");
        }
      });

      $industry.find(".js-reset-form").removeClass("is-visible");
    }
  });

  $(".js-item-hours, .js-item-value").keyup(sectionInputChange).change(sectionInputChange).keydown(filterNonNumeric);

  function sectionInputChange() {
    var $el = $(this);
    var $item = $el.parents(".js-item");
    var $section = $item.parent();
    var $sectionHeader = $section.prev();
    var $industry = $item.parents(".js-tab");

    var $hours = $item.find(".js-item-hours");

    var hours = $hours.length ? parseInt($hours.val()) : 1;
    var value = $item.find(".js-item-value").val();

    if (isNaN(hours)) {
      hours = 0;
    }

    if (isNaN(value)) {
      value = 0;
    }

    var valueDefault = $el.attr("data-default");
    var valueCurrent = $el.val();

    if (valueCurrent != valueDefault) {
      $industry.find(".js-reset-form").addClass("is-visible");
    }

    $item.find(".js-item-cost").text(hours * value);

    var sectionCost = 0;

    $section.find(".js-item-cost").each(function () {
      sectionCost += parseInt($(this).text());
    });

    $sectionHeader.find(".js-section-cost").text(sectionCost);

    var industryCost = 0;

    $industry.find(".js-section-cost").each(function () {
      industryCost += parseInt($(this).text());
    });

    $industry.find(".js-industry-cost").text(industryCost);

    $industry.find(".js-profit-margin").triggerHandler("keyup");
  }

  $(".js-profit-margin, .js-sales").keyup(totalInputChange).change(totalInputChange).keydown(filterNonNumeric);

  function totalInputChange() {
    var $el = $(this);
    var $industry = $el.parents(".js-tab");
    var $sales = $industry.find(".js-sales");
    var $margin = $industry.find(".js-profit-margin");

    var valueDefault = $el.attr("data-default");
    var valueCurrent = $el.val();

    if (valueCurrent != valueDefault) {
      $industry.find(".js-reset-form").addClass("is-visible");
    }

    if (!$sales.val() || !$margin.val()) {
      $industry.find(".js-cost-totals").addClass("u-hidden");
      return false;
    }

    var margin = $margin.val() - 2;
    var sales = $sales.val();
    var cost = $industry.find(".js-industry-cost:eq(1)").text();
    var index = 0;

    var $recoveryDays = $industry.find(".js-recovery-days");
    var $recoverySales = $industry.find(".js-recovery-sales");

    $industry.find(".js-recovery-costs").each(function () {
      var $el = $(this);
      var $day = $recoveryDays.eq(index);
      var $sale = $recoverySales.eq(index);

      if (margin > -1 && margin < 101 && sales > 0) {
        var requiredSales = cost / margin * 100;
        var requiredDays = requiredSales / sales;

        $el.text(margin).parent().removeClass("u-hidden");
        $day.text(Math.round(requiredDays)).parent().removeClass("u-hidden");
        $sale.text(Math.round(requiredSales)).parent().removeClass("u-hidden");
      } else {
        $el.parent().addClass("u-hidden");
        $day.parent().addClass("u-hidden");
        $sale.parent().addClass("u-hidden");
      }

      margin += 2;
      index += 1;
    });
  }

  function filterNonNumeric(e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
          // Allow: Ctrl+A, Command+A
        (e.keyCode == 65 && ( e.ctrlKey === true || e.metaKey === true ) ) ||
          // Allow: home, end, left, right, down, up
        (e.keyCode >= 35 && e.keyCode <= 40)) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  }
});